import Image from 'next/image';
import { Button } from '@nf/ui';
import { Icon } from '@/components/icons/svg-icons';
import { useTranslations } from 'next-intl';
import { useRouter } from '@/navigation';
import { useLocale } from 'next-intl';
import styles from './score-challenge-slider.module.scss';
import { useCwcEntry } from '@/hooks/cwc-jackpot';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { KafkaNote } from '@nf/utils-common/constants';

interface ScoreChallengeSliderProps {
  onClose: () => void;
}

export const ScoreChallengeSlider = ({ onClose }: ScoreChallengeSliderProps) => {
	const t = useTranslations('General');
	const cwcEntry = useCwcEntry();
	const router = useRouter();
	const locale = useLocale();

	const handleClickButton = async () => {
		setKafkaNormal({
			note: KafkaNote.CWCJackpot,
			type: 1,
			action: 1
		});
		cwcEntry();
		onClose();
	};

	return (
		<div className={styles.container}>
			<div className={styles.main}>
				<div className={styles.titleGroup}>
					<div className={styles.title}>{t('lbl_CWCLoginP01')}</div>
					<div className={styles.subTitle}>{t('lbl_CWCLoginP02')}</div>
				</div>
				<div className={styles.section}>
					<div className={styles.buttons}>
						<Button 
							variant="primary" 
							className={styles.button} 
							onClick={handleClickButton}
						>
							<span className={styles.buttonText}>{t('lbl_CWCPlayNow')}</span>
							<Icon name="arrow-right" className={styles.arrowIcon} />
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
}; 